import HttpHelper from '@/helpers/http';

interface IFeedbackRequest {
  message?: string;
  score: string;
  doNotShowAgain: boolean;
}

export default class FeedbackApi {
  static async create(data): Promise<IFeedbackRequest> {
    return await HttpHelper.post('/api/v1/feedback', data);
  }
}
